import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import AddCustomerService from '@/components/commons/AddCustomerService';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card-arrow';
import Head from '@/components/commons/Head';
import { useRouter } from 'next/navigation';

// const CoreTeamItem = ({
//   className,
//   name,
//   position,
//   image,
//   titles,
// }: {
//   className?: string;
//   name: string;
//   position: string;
//   image: string;
//   titles: string[];
// }) => {
//   return (
//     <div className={cn('flex h-full w-[20.8vw] flex-col items-center bg-white max-md:w-full', className)}>
//       <div className="h-[18.824vw] w-full bg-[#EEE8E5] max-md:h-auto">
//         {image && (
//           <Image src={image} alt="" width={400} height={362} className="h-full w-full object-cover object-top" />
//         )}
//       </div>
//       <div className="w-full px-[1.248vw] pb-[1.248vw] pt-[1.872vw] text-center max-md:pb-6">
//         <h2 className="mb-[0.624vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#15163D] max-md:text-base">
//           {name}
//         </h2>
//         <h2 className="mb-[1.456vw] text-[0.728vw] font-normal leading-[0.728vw] text-[#15163D] max-md:text-sm">
//           {position}
//         </h2>
//         {(titles || []).map((title, index) => (
//           <h3 key={index} className="text-[0.728vw] font-normal leading-[1.612vw] text-[#666666] max-md:text-xs">
//             {title}
//           </h3>
//         ))}
//       </div>
//     </div>
//   );
// };

const AboutUsContent = () => {
  const t = useTranslations();
  const currentLocale = useLocale();
  const router = useRouter();

  return (
    <div className="w-full">
      <Head
        title={'专注移民留学,定制方案,性价比服务,行业领先'}
        description={
          '【星环出国】作为「全球身份规划专家」，专注于移民留学、海外安家等「一站式出国方案」，业务覆盖加拿大、美国、欧洲、亚洲、澳洲及加勒比地区，拥有强大的海外持牌顾问与律师团队，成功率高达98%以上，是全球客户信赖的“出国服务商”'
        }
        keywords="加拿大移民、加拿大留学、加拿大签证、加拿大移民中介、加拿大留学中介、加拿大持牌移民顾问、温哥华移民公司、SUV、加拿大技术移民、加拿大工签、加拿大永居申请、加拿大PR、全球身份规划、美国移民、美国EB-5投资移民、美国EB-3雇主担保移民、美国绿卡申请、澳洲移民、澳澳洲482、澳186、澳洲永居申请、加勒比岛国移民、格林纳达护照移民、多米尼克护照项目、加勒比岛国护照、加勒比护照免签国家、加勒比公民身份规划"
      />
      {/* banner */}
      <div
        style={{
          backgroundImage: 'url(/images/aboutUs/bg.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        className="mb-[4.16vw] flex h-auto w-full flex-row items-end justify-between pb-[2.86vw] pl-[8.06vw] pr-[24.08vw] pt-[4.16vw] max-md:mb-6 max-md:flex-col max-md:items-start max-md:px-[30px] max-md:py-6"
      >
        <div className="w-[44.46vw] max-md:mb-6 max-md:w-full">
          <h1 className="mb-[1.04vw] text-[2.08vw] font-medium leading-[2.08vw] text-white max-md:text-base">
            {t('AboutUs.aboutUs')}
          </h1>
          <h1 className="mb-[2.288vw] text-[1.872vw] font-black leading-[1.872vw] text-white opacity-20 max-md:text-xs">
            {t('AboutUs.aboutStarRing')}
          </h1>
          <div className="text-[0.728vw] font-normal leading-[1.456vw] text-white max-md:mb-3 max-md:text-xs">
            {t('AboutUs.aboutUsContent1')}
          </div>
          <div className="text-[0.728vw] font-normal leading-[1.456vw] text-white max-md:text-xs">
            {t('AboutUs.aboutUsContent2')}
          </div>
        </div>
        <div
          className="box-border flex h-[4.264vw] w-[9.464vw] cursor-pointer flex-row items-center justify-between border-[0.104vw] border-solid border-white pl-[1.196vw] pr-[0.676vw] max-md:h-[45px] max-md:w-[90px] max-md:border-[1px] max-md:pl-[14px] max-md:pr-[9px]"
          onClick={() => {
            window.open(process.env.NEXT_PUBLIC_WEBSITE + '/about-us/star-ring-group-bio/', '_blank');
          }}
        >
          <div>
            <div className="mb-[0.26vw] text-[1.04vw] font-medium leading-[1.04vw] text-white max-md:mb-1 max-md:text-[12px] max-md:leading-[12px]">
              {t('AboutUs.companyProfile')}
            </div>
            <div className="text-[0.728vw] font-normal leading-[0.728vw] text-white opacity-80 max-md:text-[10px] max-md:leading-[10px]">
              {t('AboutUs.aboutUsEnglishText')}
            </div>
          </div>
          <Image
            src={'/images/aboutUs/rightArrow.png'}
            width={23}
            height={14}
            className="h-auto w-[1.196vw] max-md:w-3"
            alt="icon"
          />
        </div>
      </div>
      {/* 星环集团简介 */}
      <div className="w-full">
        <div className="box-border w-full px-[9.724vw] max-md:px-[30px]">
          <h1 className="mb-[1.04vw] text-[2.08vw] font-medium leading-[2.08vw] text-[#2A2B45] max-md:text-base">
            {t('AboutUs.starRingIntroduction')}
          </h1>
          <h1 className="mb-[4.992vw] text-[1.664vw] font-black uppercase leading-[1.664vw] text-[#2A2B45] opacity-20 max-md:mb-10 max-md:text-sm">
            {t('AboutUs.introduction')}
          </h1>
        </div>
        {/* 集团介绍 */}
        <div className="box-border w-full px-[8.01vw] max-md:px-[30px]">
          <div className="relative mb-[3.64vw] box-border w-full bg-[#ebebf680] px-[4.16vw] pb-[4.68vw] pt-[6.344vw] max-md:mb-10 max-md:pt-10">
            <div
              className={`absolute left-[2.08vw] top-[-1.352vw] flex h-[4.94vw] w-[16.64vw] max-md:top-[-23px] max-md:h-[46px] max-md:w-[156px] ${currentLocale === 'zh' ? 'flex-row' : 'flex-col'} items-center justify-center bg-[#3C3D5B] text-[1.248vw] leading-normal`}
            >
              <span className="mr-[0.208vw] tracking-wider text-white max-md:text-xs">
                {t('AboutUs.introductionText2')}
              </span>
              <span className="font-semibold uppercase tracking-tighter text-[#8384AB] max-md:text-xs">
                {t('AboutUs.introductionEnglishText2')}
              </span>
            </div>
            <h2 className="mb-[0.624vw] text-[1.248vw] font-medium leading-[1.248vw] text-[#6E6F8A] max-md:text-xs">
              {t('AboutUs.ourAim')}
            </h2>
            <h2 className="mb-[3.12vw] text-[1.872vw] font-medium leading-[1.872vw] text-[#2A2B45] max-md:text-sm">
              {t('AboutUs.ourAimTitle')}
            </h2>
            <div className="flex w-full flex-row justify-between max-md:flex-col">
              <h5 className="flex-1 text-[0.936vw] leading-[1.664vw] text-[#2A2B45] max-md:mb-3 max-md:w-full max-md:text-xs">
                {currentLocale === 'zh' ? (
                  <span>
                    <span className="font-medium">加拿大星环集团（Star Ring Group）</span>
                    是一家总部位于温哥华的跨国集团公司。作为「全球身份规划专家」，
                    【星环出国】专注于提供全球化移民、留学、教育、旅游及落地安家等综合服务，包括身份规划、学校申请、签证办理、创业就业支持、安家服务等「一站式出国方案」。
                  </span>
                ) : (
                  <span>
                    <span className="font-medium">Star Ring Group</span>
                    {`, headquartered in Vancouver, Canada, is a
                    multinational corporation. As a "Global Identity Planning Expert",{' '}
                    <strong>Star Ring Immigration</strong> specializes in providing comprehensive international
                    services, including immigration, overseas education, academic consulting, travel arrangements, and
                    settlement assistance. Our all-in-one solutions cover identity planning, school applications, visa
                    processing, entrepreneurial and employment support, and post-arrival settlement services.`}
                  </span>
                )}
              </h5>
              <div className="mx-5 h-auto w-[1px] bg-[#6E6F89] max-md:mb-3 max-md:hidden"></div>
              <h5 className="flex-1 text-[0.936vw] leading-[1.664vw] text-[#2A2B45] max-md:mb-3 max-md:w-full max-md:text-xs">
                {currentLocale === 'zh'
                  ? `【星环出国】拥有强大、丰富而本地化的持牌移民顾问、律师、教育专家及职业导师资源，业务范围覆盖加拿大、美国、欧洲、亚洲、澳洲及加勒比地区，成功案例数以千计。`
                  : `Star Ring Immigration is backed by a strong, diverse, and locally-based team of licensed immigration consultants, lawyers, education specialists, and career mentors.  
     Our service network spans Canada, the United States, Europe, Asia, Australia, and the Caribbean, with thousands of successful cases to date.`}
              </h5>
              <div className="mx-5 h-auto w-[1px] bg-[#6E6F89] max-md:mb-3 max-md:hidden"></div>
              <h5 className="flex-1 text-[0.936vw] leading-[1.664vw] text-[#2A2B45] max-md:w-full max-md:text-xs">
                {currentLocale === 'zh'
                  ? `自创立伊始10余年，星环始终秉承【以诚为本，做行业清流】的理念，凭借专业的服务与极高的移民留学成功率（98%以上），多次获得加拿大政府与商会颁发的「杰出企业」殊荣，「BBB北美商业改进局」A+级企业认证，以及「谷歌」五星级客户评价，是全球客户信赖的“出国服务商”。`
                  : `Since its founding over a decade ago, Star Ring has upheld the principle of "Integrity First, Excellence Always," distinguishing itself as a trusted name in the industry.  
     With a professional team and an exceptional success rate of over 98% in immigration and study abroad cases, Star Ring has received multiple "Outstanding Enterprise" awards from the Canadian government and chambers of commerce.  
     The company is also accredited with an A+ rating by the Better Business Bureau (BBB) of North America and holds a five-star rating on Google, making it a globally trusted provider of international relocation services.`}
              </h5>
            </div>
          </div>
        </div>
        {/* 团队展示 */}
        {/* <div className="box-border w-full px-[8.01vw] max-md:px-[30px]">
          <div className="relative mb-[5.512vw] box-border w-full bg-[#ebebf680] px-[1.456vw] pb-[5.98vw] pt-[8.84vw] max-md:mb-10 max-md:pt-10">
            <div className="absolute left-[2.08vw] top-[-1.352vw] flex h-[4.94vw] w-[16.64vw] flex-row items-center justify-center bg-[#3C3D5B] text-[1.248vw] leading-[1.248vw] max-md:top-[-23px] max-md:h-[46px] max-md:w-[156px]">
              <span className="mr-[0.208vw] tracking-wider text-white max-md:text-xs">{t('AboutUs.coreTeam')}</span>
              <span className="font-semibold uppercase tracking-tighter text-[#8384AB] max-md:text-xs">
                {t('AboutUs.coreTeamEnglishText')}
              </span>
            </div>
            <div className="box-border w-full px-[5.2vw]">
              <Carousel
                opts={{
                  align: 'start',
                }}
              >
                <CarouselContent className="ml-0">
                  {[
                    {
                      name: 'Christian Yuan',
                      position: 'Founder & President',
                      image: `/images/aboutUs/ChristianYuan.png`,
                      titles: ['加拿大星环集团 创始人兼董事长', 'Welink微联英才 创始人兼CEO'],
                    },
                    {
                      name: 'Angel Men',
                      position: 'Co-Founder & Vice President',
                      image: `/images/aboutUs/AngelMen.png`,
                      titles: ['加拿大星环集团 联合创始人兼副总裁', '资深移民留学顾问', '北美资深教育专家'],
                    },
                    {
                      name: 'Anna Huang',
                      position: 'Co-founder & Vice President',
                      image: `/images/aboutUs/AnnaHuang.png`,
                      titles: [
                        '加拿大星环集团 联合创始人兼副总裁',
                        '加拿大RCIC资深持牌移民顾问',
                        '北大光华温哥华校友会 执行会长',
                      ],
                    },
                    {
                      name: 'Tom Tang',
                      position: 'Regional Director in Quebec',
                      image: `/images/aboutUs/TomTang.png`,
                      titles: ['千里之行始于足下，我们能帮你走得更远！'],
                    },
                    {
                      name: 'Dodge B.',
                      position: 'Case Manager & Senior Immigration Consultant',
                      image: `/images/aboutUs/DodgeB.png`,
                      titles: ['The best way to predict the future is to create it.'],
                    },
                    {
                      name: 'Hellen Wang',
                      position: 'Administrative Manager',
                      image: `/images/aboutUs/HellenWang.png`,
                      titles: ['微笑和善意是对生命最好的滋养！'],
                    },
                    {
                      name: 'Yang Zhang',
                      position: 'Marketing&Sales Manager',
                      image: `/images/aboutUs/YangZhang.png`,
                      titles: ['今天的收获，是昨天的耕耘！'],
                    },
                    {
                      name: 'Chen Chen',
                      position: 'Regional Sales Manager',
                      image: `/images/aboutUs/ChenChen.jpg`,
                      titles: ['以诚为本，做行业清流！'],
                    },
                    {
                      name: 'Hamza S. Bashir',
                      position: 'Business Development Officer',
                      image: `/images/aboutUs/HamzaSBashir.png`,
                      titles: ['Think global, act global'],
                    },
                    {
                      name: 'Amro Shehata',
                      position: 'Senior Immigration Consultant',
                      image: `/images/aboutUs/AmroShehata.png`,
                      titles: ['There is no substitute for hard work.'],
                    },
                    {
                      name: 'Sylvia Sun',
                      position: 'Senior Case Assistant',
                      image: `/images/aboutUs/SylviaSun.png`,
                      titles: ['以诚为本，做行业清流！'],
                    },
                    {
                      name: 'Lucia Niu',
                      position: 'Case Assistant',
                      image: `/images/aboutUs/LuciaNiu.png`,
                      titles: ['努力造就实力，态度决定高度'],
                    },
                    {
                      name: 'Henry Yang',
                      position: 'Case Assistant',
                      image: `/images/aboutUs/HenryYang.png`,
                      titles: ['There are no shortcuts to success'],
                    },
                    {
                      name: 'Nicole Yang',
                      position: 'Marketing Specialist',
                      image: '/images/aboutUs/NicoleYang.jpg',
                      titles: ['不驰于空想，不骛于虚声。'],
                    },
                    {
                      name: 'Wenbo Xia',
                      position: 'Office Assistant (Manitoba Branch)',
                      image: `/images/aboutUs/WenboXia.png`,
                      titles: ['The way to get started is to quit talking and begin doing'],
                    },
                    {
                      name: 'Peter Xu',
                      position: 'Executive Assistant',
                      image: `/images/aboutUs/PeterXu.png`,
                      titles: ['此处心安是吾乡。'],
                    },
                  ].map((item, index) => (
                    <CarouselItem key={index} className={`basis-1/3 max-md:basis-full max-md:pl-0`}>
                      <CoreTeamItem key={index} {...item} />
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="-left-[4.992vw] h-[4.368vw] w-[4.316vw] border-none shadow-none max-md:hidden" />
                <CarouselNext className="-right-[4.992vw] h-[4.368vw] w-[4.316vw] border-none shadow-none max-md:hidden" />
              </Carousel>
            </div>
          </div>
        </div> */}
      </div>
      {/* 星环活动与报道 */}
      <div className="mb-[6.968vw] box-border w-full px-[9.724vw] max-md:px-[30px]">
        <h1 className="mb-[1.04vw] text-[2.08vw] font-medium leading-[2.08vw] text-[#2A2B45] max-md:text-base">
          {t('AboutUs.eventsReports')}
        </h1>
        <h1 className="mb-[4.992vw] text-[1.664vw] font-black uppercase leading-[1.664vw] text-[#2A2B45] opacity-20 max-md:text-xs">
          {t('AboutUs.eventsReportsEnglishText')}
        </h1>
        <div className="grid grid-cols-3 gap-x-[1.3vw] gap-y-[1.352vw] max-md:grid-cols-1">
          {[
            { url: '/activities' },
            { url: '' },
            { url: '' },
            { url: 'https://www.xiaohongshu.com/user/profile/5c1ca7a400000000070235e5' },
            { url: 'https://www.zhihu.com/org/xing-huan-yi-min-liu-xue' },
            { url: 'https://www.facebook.com/profile.php?id=100057589413759' },
          ].map((item, index) => {
            if (index == 1 || index == 2) {
              return (
                <HoverCard key={index}>
                  <HoverCardTrigger>
                    <div
                      style={{
                        backgroundImage: `url('/images/aboutUs/eventsReports${index + 1}.png')`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                      }}
                      className="box-border flex h-[15.6vw] w-full scale-100 cursor-pointer flex-col items-center justify-center rounded-2xl transition-transform duration-500 hover:scale-[110%] max-md:mb-2 max-md:h-[60px]"
                      onClick={() => {
                        if (item.url) {
                          if (item.url.startsWith('http') || item.url.startsWith('https')) {
                            window.open(item.url, '_blank');
                          } else {
                            window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${item.url}`, '_blank');
                          }
                        }
                      }}
                    >
                      <h2 className="mb-[0.936vw] text-center text-[1.248vw] font-medium leading-[1.248vw] text-white max-md:text-sm">
                        {t(`AboutUs.eventsReportsTitle${index + 1}` as any)}
                      </h2>
                      <h2 className="text-center text-[0.936vw] font-medium leading-[0.936vw] text-white opacity-80 max-md:text-xs">
                        {t(`AboutUs.eventsReportsEnglishTitle${index + 1}` as any)}
                      </h2>
                    </div>
                  </HoverCardTrigger>
                  <HoverCardContent className="bg-white py-[52px]">
                    {
                      // eslint-disable-next-line @next/next/no-img-element
                      <img
                        src={index === 1 ? '/images/footer/wechatNumber1.png' : '/images/home/contactUsLogoQrcode1.png'}
                        width={120}
                        height={120}
                        className="m-auto size-[120px]"
                        alt="contactUsLogo"
                      />
                    }
                  </HoverCardContent>
                </HoverCard>
              );
            }
            return (
              <div
                key={index}
                style={{
                  backgroundImage: `url('/images/aboutUs/eventsReports${index + 1}.png')`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }}
                className="box-border flex h-[15.6vw] w-full cursor-pointer flex-col items-center justify-center rounded-2xl max-md:mb-2 max-md:h-[60px]"
                onClick={() => {
                  if (item.url) {
                    if (item.url === '/activities') {
                      router.push('/activities');
                    } else if (item.url.startsWith('http') || item.url.startsWith('https')) {
                      window.open(item.url, '_blank');
                    } else {
                      window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${item.url}`, '_blank');
                    }
                  }
                }}
              >
                <h2 className="mb-[0.936vw] text-center text-[1.248vw] font-medium leading-[1.248vw] text-white max-md:text-sm">
                  {t(`AboutUs.eventsReportsTitle${index + 1}` as any)}
                </h2>
                <h2 className="text-center text-[0.936vw] font-medium leading-[0.936vw] text-white opacity-80 max-md:text-xs">
                  {t(`AboutUs.eventsReportsEnglishTitle${index + 1}` as any)}
                </h2>
              </div>
            );
          })}
        </div>
      </div>
      {/* 添加客服 */}
      <AddCustomerService />
    </div>
  );
};

export default AboutUsContent;
